import { safeLocalStorage } from '@/lib/safeStorage';

/**
 * The one phone number a new owner types at registration, and what they said it is.
 * Registration keeps it here so the company step never asks again: a company line
 * becomes the company's phone; a mobile stays the owner's, and the company phone is
 * a setup reminder later. Cleared once the company exists.
 */
export const SIGNUP_PHONE_STORAGE_KEY = 'ruta_signup_phone';

export type SignupPhoneKind = 'personal' | 'company';

export interface SignupPhone {
  /** E.164, e.g. +16125550100. */
  number: string;
  kind: SignupPhoneKind;
}

export function rememberSignupPhone(phone: SignupPhone): void {
  if (!phone.number) return;
  safeLocalStorage.setItem(SIGNUP_PHONE_STORAGE_KEY, JSON.stringify(phone));
}

export function recalledSignupPhone(): SignupPhone | null {
  try {
    const raw = safeLocalStorage.getItem(SIGNUP_PHONE_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<SignupPhone>;
    if (typeof parsed.number !== 'string' || !parsed.number) return null;
    if (parsed.kind !== 'personal' && parsed.kind !== 'company') return null;
    return { number: parsed.number, kind: parsed.kind };
  } catch {
    return null;
  }
}

export function clearSignupPhone(): void {
  safeLocalStorage.removeItem(SIGNUP_PHONE_STORAGE_KEY);
}
